import { render, staticRenderFns } from "./AssignUserModal.vue?vue&type=template&id=2a27ca84"
import script from "./AssignUserModal.vue?vue&type=script&lang=js"
export * from "./AssignUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports